import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { a as s } from "../../../../index-CROKJrb5.js";
import { c as e, f as m } from "../../../../create-component-CBAeEoQ6.js";
import { CardTitle as i } from "../../CardTitle/index.js";
const l = e(
  "ControlCardTitle",
  m(
    ({ className: r, ...o }, t) => /* @__PURE__ */ a.jsx(
      i,
      {
        ref: t,
        className: s("cur-shrink", r),
        ...o
      }
    )
  )
);
export {
  l as ControlCardTitle
};
//# sourceMappingURL=index.js.map
